import {
  AuditEvent,
  AdoTestPlan,
  JiraTestPlan,
  TestPlan,
} from '../../interfaces/ui/testPlan';
import { mapJiraTestSuites } from './testSuite.response.dto';

import { ProjectMappingType } from '../../interfaces/ui/addProjectModal';

const parseJiraDate = (value: unknown): Date | undefined => {
  if (typeof value !== 'string' || !value.trim()) return undefined;
  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? undefined : parsedDate;
};

const mapAuditEvent = (
  auditData: any,
  userKey: 'createdBy' | 'updatedBy',
  dateKey: 'createdOn' | 'updatedOn',
): AuditEvent | undefined => {
  if (!auditData) return undefined;

  const by = auditData.by || auditData[userKey];
  const on = parseJiraDate(auditData.on || auditData[dateKey]);

  if (!by || !on) return undefined;

  return {
    by,
    on,
  };
};

function mapJiraTestPlans(testPlanData: any[]): JiraTestPlan[] {
  return testPlanData.map(testPlan => {
    return {
      id: testPlan.id,
      name: testPlan.name,
      sequence: testPlan.sequence ?? testPlan.seqNo,
      parentId: testPlan.parentId?.toString(),
      children: mapJiraTestSuites(testPlan.children || []),
      created: mapAuditEvent(testPlan.created, 'createdBy', 'createdOn'),
      updated: mapAuditEvent(testPlan.updated, 'updatedBy', 'updatedOn'),
    };
  });
}

function mapAdoTestPlans(testPlanData: any[]): AdoTestPlan[] {
  return testPlanData.map(testPlan => {
    return {
      id: testPlan.id,
      name: testPlan.name,
      iteration: testPlan.iteration,
      url: testPlan.url,
    };
  });
}

export function mapTestPlanResponse(
  response: any,
  tool: ProjectMappingType,
): TestPlan[] {
  if (!response) {
    return [];
  }
  let mapped: TestPlan[] = [];
  switch (tool) {
    case 'ADO':
      const adoData = response?.data?.testplans?.value;
      if (!adoData) return [];
      mapped = mapAdoTestPlans(adoData);
      break;
    case 'JIRA':
      const jiraData = response?.data?.testplans?.data;
      if (!jiraData) return [];
      mapped = mapJiraTestPlans(jiraData);
      break;
  }
  return mapped;
}
